var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"capsim-wrapper",attrs:{"id":"capsim-container"}},[_vm._t("top"),_vm._v(" "),(_vm.header)?_c('span',{staticClass:"container-header"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.header)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container-row"},[_vm._t("default")],2),_vm._v(" "),_vm._t("bottom")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }